module.exports = __webpack_public_path__ + "img/other.d5677c39.svg";